<div class="app-main__inner">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card devices-card">
        <div class="card-header">
          <h4 class="card-title">Devices</h4>
          <div class="card-header-action">
            <button type="button" class="btn btn-primary btn-round btn-shadow" title="Add"
              (click)="openDeviceModal({})"><i class="fa fa-plus"></i> Add Device</button>
            <!--(click)="setConfigModal();"-->
          </div>
        </div>
        <div class="card-body">
          <vio-table *ngIf="deviceListTable" [tableConfig]="deviceListTableConfig" [tableData]="deviceListTableData"
            [tableHeader]="deviceListTableHeader" (buttonClickEvent)="buttonClickEvent($event)"></vio-table>
        </div>
      </div>
    </div>
  </div>
</div>